import * as React from 'react';
export default abstract class ComponentBasic<P= {}, S= {}> extends React.PureComponent<P, S> {
    constructor(props: P) {
        super(props);
    }
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-scaffold-framework/component/ComponentBasic.tsx